<template>
    <ion-item v-if="$store.getters.monthlyMessageLimitExceeded" color="danger" @click="upgrade" button>
        <ion-text style="padding: 5px 0;">{{ $t('ncrypt.errors.monthly_message_limit_reached') }}</ion-text>
    </ion-item>
</template>

<script>
    import {MenuHandler} from "../../services/MenuHandler";

    export default {
        name: "MonthlyMessageLimit",
        methods: {
            upgrade() {
                MenuHandler.open('pro');
            },
        },
    }
</script>
